import { render, staticRenderFns } from "./province-select.vue?vue&type=template&id=42436a71&scoped=true"
import script from "./province-select.vue?vue&type=script&lang=js"
export * from "./province-select.vue?vue&type=script&lang=js"
import style0 from "./province-select.vue?vue&type=style&index=0&id=42436a71&prod&lang=less&scoped=true"
import style1 from "./province-select.vue?vue&type=style&index=1&id=42436a71&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42436a71",
  null
  
)

export default component.exports